<template>
    <school-icon-styled :size="size" :marginRight="marginRight">
        <img :src="path || default_path" />
    </school-icon-styled>
</template>
<script>
import styled from "vue-styled-components";

const props = {
    size: {
        type: Number,
        default: () => 2.4
    },
    marginRight: {
        type: Number,
        default: () => 1.8
    }
};

const SchoolIconStyled = styled("div", props)`
    width: ${props => props.size}rem;
    height: ${props => props.size}rem;
    border-radius: ${props => props.size}rem;
    overflow: hidden;
    border: 1px solid ${props => props.theme.color.line};
    margin-right: ${props => props.marginRight}rem;

    img {
        width: 100%;
    }
`;

export default {
    name: "SchoolIcon",
    data: () => ({
        default_path: "http://api.school-mom.kr/service/img/school_default.png"
    }),
    props: {
        ...props,
        path: String
    },
    components: {
        SchoolIconStyled
    }
};
</script>
